import React from "react";
import { Routes, Route, Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import TermsOfService from "./pages/emily/terms";
import PrivacyPolicy from "./pages/emily/privacy";
import TrialistLandingPage from "./pages/trialist";
import TrialistTermsOfService from "./pages/trialist/terms";
import TrialistPrivacyPolicy from "./pages/trialist/privacy";
import TrialistContactPage from "./pages/trialist/contact";
import MemsPrivacyPolicy from "./pages/mems/privacy";
import MemsTermsOfService from "./pages/mems/terms";

const LandingPage = () => {
  return (
    <div className='min-h-screen bg-black text-white flex flex-col justify-center items-center'>
      <main className='text-center p-8 flex flex-col items-center'>
        <div className='mb-8'>
          <Sparkles className='w-10 h-10 text-blue-500 animate-pulse' />
        </div>

        <h1 className='text-4xl font-bold mb-4'>Anyone Labs</h1>

        <p className='text-xl mb-12 max-w-md mx-auto text-gray-300'>
          An app studio.
        </p>

        <div className='space-y-8'>
          <div className='space-y-2'>
            <h2 className='text-2xl font-semibold text-blue-500'>Emily</h2>
            <p className='text-lg text-gray-300'>
              Your AI Personal Receptionist
            </p>
          </div>

          <div className='space-y-2'>
            <h2 className='text-2xl font-semibold text-green-500'>Trialist</h2>
            <p className='text-lg text-gray-300'>
              Research Study App
            </p>
          </div>

          <div className='space-y-2'>
            <h2 className='text-2xl font-semibold text-orange-500'>Mems</h2>
            <p className='text-lg text-gray-300'>
              Your memories, as mini-movies
            </p>
            <p className='text-sm text-gray-500'>
              <Link to='/mems/privacy' className='hover:text-gray-300'>Privacy</Link>
              {" · "}
              <Link to='/mems/terms' className='hover:text-gray-300'>Terms</Link>
            </p>
          </div>
        </div>
      </main>

      <footer className='absolute bottom-4 text-center text-gray-600 text-xs'>
        <p>&copy; 2024 Anyone Labs</p>
        <div className='mt-2'>
          <a href='mailto:team@anyonelabs.com' className='hover:text-gray-400'>
            Contact
          </a>
        </div>
      </footer>
    </div>
  );
};

const App = () => {
  return (
    <Routes>
      <Route path='/' element={<LandingPage />} />
      <Route path='/emily/terms' element={<TermsOfService />} />
      <Route path='/emily/privacy' element={<PrivacyPolicy />} />
      <Route path='/trialist' element={<TrialistLandingPage />} />
      <Route path='/trialist/terms' element={<TrialistTermsOfService />} />
      <Route path='/trialist/privacy' element={<TrialistPrivacyPolicy />} />
      <Route path='/trialist/contact' element={<TrialistContactPage />} />
      <Route path='/mems/privacy' element={<MemsPrivacyPolicy />} />
      <Route path='/mems/terms' element={<MemsTermsOfService />} />
    </Routes>
  );
};

export default App;
